import React, { memo, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import { useStyles } from './styles';
import { GeneralModel } from 'modules/models';
import Loader from 'modules/views/shared/Loader';
import { Grid } from '@material-ui/core';

export interface IDenyUserProps {
  denyUserResult: any;
  denyUserLoading: GeneralModel.ILoadingStatus;
  denyUser: (userId: string, companyId: string, projectId: string) => void;
}

export interface IQueryParams {
  companyUserId: string;
  userId: string;
  companyId: string;
  projectId: string;
}

const DenyUser = ({ denyUserResult, denyUserLoading, denyUser }: IDenyUserProps) => {
  const classes = useStyles();

  const { companyUserId, userId, companyId, projectId } = useParams<IQueryParams>();

  useEffect(() => {
    if (userId && companyId && projectId) {
      if (localStorage.getItem('deny' + userId + '-' + companyId + '-' + projectId) === 'true') {
        localStorage.removeItem('deny' + userId + '-' + companyId + '-' + projectId);
        denyUser(userId, companyId, projectId);
      } else {
        localStorage.setItem('deny' + userId + '-' + companyId + '-' + projectId, 'true');
      }
    }
  }, []);

  return (
    <Grid className={classes.container}>
      {denyUserLoading && denyUserLoading.isLoading ? (
        <>
          <Grid>Loading...</Grid>
          <Loader />
        </>
      ) : (
        <Grid>
          {denyUserResult && <Grid className={classes.successMessage}>User denied successfully.</Grid>}
          {denyUserLoading && denyUserLoading.error && denyUserLoading.error.length > 0 && (
            <Grid className={classes.errorMessage}>{denyUserLoading.error}</Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default memo(DenyUser);
